export default __webpack_public_path__ + "static/media/trip-stop.0d85bc1b.svg";